import React, { Component } from 'react'
import { connect } from 'dva'
import { Col, Row, Table, DatePicker } from 'antd'
import { ExportOutlined } from '@ant-design/icons'
import './styles.less'
import moment from 'moment'
import BasicLayout from '../../components/BasicLayout'
import { routerRedux } from 'dva/router'
import NumericConversion from '../../utils/utils'
import { getToken } from '../../utils/authority'
import qs from 'query-string'
import Config from '../../config/Config'

const { RangePicker } = DatePicker;

function disabledDate(current) {
  let time = moment().add(1, 'days').format('YYYY-MM-DD');
  return current && !moment(current).isBefore(time);
}

class CompanyDetails extends Component {
  constructor(props) {
    super(props)
    let id = props.match.params.id;
    this.state = {
      id: id,
      catalogSelected: [
        {value: 'sumAnchor'},
        {value: []},
        {value: []},
        {value: []},
        {value: 'all'},
        {value: '0'}
      ],
      date: [],
      search: {
        cate: 'sumAnchor',
      },
      showMore: false,
    }
  }

  // 生成筛选器目录配置（动态生成）
  getCatalog = () => {
    const { segmentList = [], genreList = [] } = this.props
    return [
      {
        nameEN: 'Metric',
        nameCN: '维度',
        list: [
          { nameEN: 'Live Streamers', nameCN: '主播数量', value: 'sumAnchor' },
          { nameEN: 'Hours Streamed', nameCN: '主播时长', value: 'sumLenth' },
          { nameEN: 'Subscribers', nameCN: '游戏粉丝数', value: 'sumFans' },
          { nameEN: 'Tips', nameCN: '游戏打赏收入', value: 'sumGift' },
          { nameEN: 'Heat Index', nameCN: '游戏热力值', value: 'sumHot' },
          { nameEN: 'Niko Index', nameCN: 'NIKO指数', value: 'sumNiko' }
        ]
      },
      {
        nameEN: 'Platform',
        nameCN: '流媒体网站',
        list: [
          { nameEN: 'DouYu', value: '103' },
          { nameEN: 'HuYa', value: '102' },
          { nameEN: 'Bilibili', value: '101' },
        ]
      },
      {
        nameEN: 'Game Platform',
        nameCN: '平台',
        list: [
          ...(segmentList || []).map(segment => ({
            nameEN: segment.name,
            value: segment.id
          }))
        ]
      },
      {
        nameEN: 'Genre',
        nameCN: '类型',
        list: [
          ...(genreList || []).map(genre => ({
            nameEN: genre.name,
            value: genre.id
          }))
        ]
      },
      {
        nameEN: 'Licensing Status',
        nameCN: '注册许可',
        list: [
          { nameEN: 'Licensed', nameCN: '已注册', value: 'licensed' },
          { nameEN: 'Unlicensed', nameCN: '未注册', value: 'unlicensed' }
        ]
      },
      {
        nameEN: 'Timeframe',
        nameCN: '时间段',
        list: [
          { nameEN: 'Daily', nameCN: '昨天', value: '0' },
          { nameEN: 'Last 7 Days', nameCN: '近一周', value: '1' },
          { nameEN: 'Last 30 Days', nameCN: '近一月', value: '2' },
          { nameEN: 'Custom Range', nameCN: '自定义', value: '3' }
        ]
      }
    ]
  }

  componentDidMount() {
    document.documentElement.scrollTop = 0
    const { id } = this.state
    this.props.dispatch({
      type: 'company/apiGetCompanyDetails',
      payload: { operatorID: parseInt(id) }
    })
    this.props.dispatch({
      type: 'gameList/apiGetSegments'
    })
    this.props.dispatch({
      type: 'gameList/apiGetGenres'
    })
  }
  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    const { search } = this.state
    const { companyDetails } = this.props
    if(companyDetails !== nextProps.companyDetails && nextProps.companyDetails){
      this.props.dispatch({
        type: 'company/apiGetCompanyGame',
        payload: { page: 1, Operator: nextProps.companyDetails.operator, ...search }
      })
    }
  }
  UNSAFE_componentWillUpdate(nextProps, nextState, nextContext) {
    const { companyDetails } = this.props
    const { catalogSelected, date } = this.state
    if((catalogSelected !== nextState.catalogSelected && nextState.catalogSelected) || date!==nextState.date){
      let payload = {}
      payload.startDate = nextState.date[0] ? nextState.date[0] : null
      payload.endDate = nextState.date[1] ? nextState.date[1] : null
      payload.cate = nextState.catalogSelected[0].value
      payload.platformID = nextState.catalogSelected[1].value.length!==0 ? nextState.catalogSelected[1].value.map((vo)=>{return vo}).join(',') : null
      payload.Platform = nextState.catalogSelected[2].value.length!==0 ? nextState.catalogSelected[2].value.map((vo)=>{return vo}).join(',') : null
      payload.gameGenre = nextState.catalogSelected[3].value.length!==0 ? nextState.catalogSelected[3].value.map((vo)=>{return vo}).join(',') : null
      if (nextState.catalogSelected[4].value && nextState.catalogSelected[4].value !== 'all') {
        payload.licensed = nextState.catalogSelected[4].value
      }
      this.setState({ search: payload })
      this.props.dispatch({
        type: 'company/apiGetCompanyGame',
        payload: { page: 1, Operator: companyDetails.operator, ...payload }
      })
    }
  }

  handleSelectCatalog = (item, index) => {
    const { catalogSelected, date } = this.state
    // index 0: Metrics, index 4: Licensed, index 5: Time Period 为单选
    if(index === 0 || index === 4 || index === catalogSelected.length-1){
      if(catalogSelected[index].value === item){
        catalogSelected[index].value = null
        if(index === catalogSelected.length-1){
          this.setState({ date: [] })
        }
        return
      }
      catalogSelected[index].value = item
      if(index === catalogSelected.length-1){
        if(item && (item==='0' || item==='3')){
          this.setState({ date: [] })
          return
        }else if(item && item==='1'){
          date[0] = moment().subtract(7, 'days').format('YYYY-MM-DD')
          date[1] = moment().subtract(1, 'days').format('YYYY-MM-DD')
        }else if(item && item==='2'){
          date[0] = moment().subtract(30, 'days').format('YYYY-MM-DD')
          date[1] = moment().subtract(1, 'days').format('YYYY-MM-DD')
        }
        this.setState({ date: date.concat() })
      }
    }else{
      let key = catalogSelected[index].value.indexOf(item)
      if(key<0){
        if(!item){
          catalogSelected[index].value = []
        }else{
          catalogSelected[index].value.push(item)
        }
      }else{
        catalogSelected[index].value.splice(key, 1)
      }
    }
    this.setState({ catalogSelected: catalogSelected.concat() })
  }
  handleChangeDate = (time, dateString) => {
    const { date } = this.state
    if(time){
      date[0] = moment(time[0]).format('YYYY-MM-DD')
      date[1] = moment(time[1]).format('YYYY-MM-DD')
      this.setState({ date: date.concat() })
    }
  }
  handleJumpToDetails = (id) => {
    if(id){
      this.props.dispatch(routerRedux.push(`/gameList/gameDetails/${id}`))
    }
  }
  renderTable = () => {
    const { search } = this.state
    const { companyGame, page, perPage, locale } = this.props
    const pagination = {
      current: parseInt(page) || 0,
      total: (companyGame || {}).total || 0,
      defaultCurrent: 1,
      defaultPageSize: parseInt(perPage) || 0,
      pageSize: perPage,
      showQuickJumper: true,
      position: 'bottom',
    };
    const columns = [
      {
        title: <div className={'cate_header'}>{locale==='EN' ? 'Rank' : '排名'}</div>,
        key: 'id',
        width: '5%',
        render: (record, row, index) => {
          let key = page > 1 ? (page * perPage) - perPage + index + 1 : index + 1
          return (
            <div className="ranking">
              {key}
            </div>
          )
        }
      },
      {
        title: <div className={'cate_header'}>{locale==='EN' ? 'Game' : '游戏'}</div>,
        key: 'gameInfo',
        width: '20%',
        render: (record, row, index) => {
          return (
            <div className="inline" onClick={()=>{this.handleJumpToDetails(record.gameID)}}>
              <div className="logo">
                {record.gameInfo && record.gameInfo.link ? <img alt={'img'} src={record.gameInfo.link}/> : null}
              </div>
              {record.gameInfo ? <div className="name">{locale==='EN' ? record.gameInfo.gameEn : record.gameInfo.game}</div> : null}
            </div>
          )
        }
      },
      {
        title: <div className={`cate_header ${search.cate==='sumAnchor' ? 'cate_selected' : null}`}>
          <div>{locale==='EN' ? 'Number of Live Streamers' : '主播数量'}</div>
          {companyGame&&companyGame.amountDatas ? <div className={search.cate==='sumAnchor' ? 'total_number' : null}>{NumericConversion(companyGame.amountDatas[0].sumAnchor)}</div> : null}
        </div>,
        key: 'sumAnchor',
        dataIndex: 'sumAnchor',
        width: '13%',
        align: 'right',
        render: (record, row, index) => {
          return (
            <div className="custom_txt" style={search.cate==='sumAnchor' ? {color: '#F4791F'} : null}>{NumericConversion(record)}</div>
          )
        }
      },
      {
        title: <div className={`cate_header ${search.cate==='sumLenth' ? 'cate_selected' : null}`}>
          <div>{locale==='EN' ? 'Hours Streamed' : '主播时长'}</div>
          {companyGame&&companyGame.amountDatas ? <div className={search.cate==='sumLenth' ? 'total_number' : null}>{NumericConversion(companyGame.amountDatas[0].sumLenth)}</div> : null}
        </div>,
        key: 'sumLenth',
        dataIndex: 'sumLenth',
        width: '12.4%',
        align: 'right',
        render: (record, row, index) => {
          return (
            <div className="custom_txt" style={search.cate==='sumLenth' ? {color: '#F4791F'} : null}>{NumericConversion(record)}</div>
          )
        }
      },
      {
        title: <div className={`cate_header ${search.cate==='sumFans' ? 'cate_selected' : null}`}>
          <div>{locale==='EN' ? 'Subscribers' : '游戏粉丝数'}</div>
          {companyGame&&companyGame.amountDatas ? <div className={search.cate==='sumFans' ? 'total_number' : null}>{NumericConversion(companyGame.amountDatas[0].avgFans)}</div> : null}
        </div>,
        key: 'avgFans',
        dataIndex: 'avgFans',
        width: '12.4%',
        align: 'right',
        render: (record, row, index) => {
          return (
            <div className="custom_txt" style={search.cate==='sumFans' ? {color: '#F4791F'} : null}>{NumericConversion(record)}</div>
          )
        }
      },
      {
        title: <div className={`cate_header ${search.cate==='sumGift' ? 'cate_selected' : null}`}>
          <div>{locale==='EN' ? 'Amount of Tips' : '游戏打赏收入'}</div>
          {companyGame&&companyGame.amountDatas ? <div className={search.cate==='sumGift' ? 'total_number' : null}>{locale==='EN' ? NumericConversion(companyGame.amountDatas[0].USsumGift) : NumericConversion(companyGame.amountDatas[0].sumGift)}</div> : null}
        </div>,
        key: 'sumGift',
        dataIndex: locale==='EN' ? 'USsumGift' : 'sumGift',
        width: '12.4%',
        align: 'right',
        render: (record, text) => {
          return (
            <div className="custom_txt" style={search.cate==='sumGift' ? {color: '#F4791F'} : null}>{NumericConversion(record)}</div>
          )
        }
      },
      {
        title: <div className={`cate_header ${search.cate==='sumHot' ? 'cate_selected' : null}`}>
          <div>{locale==='EN' ? 'Heat Index' : '游戏热力值'}</div>
          {companyGame&&companyGame.amountDatas ? <div className={search.cate==='sumHot' ? 'total_number' : null}>{NumericConversion(companyGame.amountDatas[0].avgHot)}</div> : null}
        </div>,
        key: 'avgHot',
        dataIndex: 'avgHot',
        width: '12.4%',
        align: 'right',
        render: (record, text) => {
          return (
            <div className="custom_txt" style={search.cate==='sumHot' ? {color: '#F4791F'} : null}>{NumericConversion(record)}</div>
          )
        }
      },
      {
        title: <div className={`cate_header ${search.cate==='sumNiko' ? 'cate_selected' : null}`}>
          <div>{locale==='EN' ? 'Niko Index' : 'Niko指数'}</div>
          {companyGame&&companyGame.amountDatas ? <div className={search.cate==='sumNiko' ? 'total_number' : null}>{NumericConversion(companyGame.amountDatas[0].sumNiko)}</div> : null}
        </div>,
        key: 'sumNiko',
        dataIndex: 'sumNiko',
        width: '12.4%',
        align: 'right',
        render: (record, text) => {
          return (
            <div className="custom_txt" style={search.cate==='sumNiko' ? {color: '#F4791F'} : null}>{NumericConversion(record)}</div>
          )
        }
      }
    ]
    return (
      <Table
        dataSource={(companyGame || {}).data || []}
        columns={columns}
        pagination={pagination}
        rowKey={record => record.gameID}
        bordered={true}
        onChange={this.handleTableChange}
      />
    )
  }
  handleTableChange = (pagination, filters, sorter) => {
    const { companyDetails } = this.props
    const { search } = this.state
    this.props.dispatch({
      type: 'company/apiGetCompanyGame',
      payload: { page: pagination.current, perPage: pagination.pageSize,  Operator: companyDetails.operator, ...search }
    })
  }
  handleExport = () => {
    const { search } = this.state
    const { companyDetails, userInfo } = this.props
    if(userInfo && userInfo.status!=='test' && userInfo.status!=='off'){
      search.page = 1
      search.Operator = companyDetails.operator
      for (let index in search){
        if(!search[index]){
          delete search[index]
        }
      }
      window.open(`${Config.SERVER_HOME}downloadCompany?WebAuth=${getToken()}&${qs.stringify(search)}`)
      this.props.dispatch({
        type: 'user/apiPostDownloadFiles',
        payload: { userID: parseInt(userInfo.id), fileID: 3 }
      })
    }else{
      this.props.dispatch({ type: 'user/setState', payload: { forbidDownload: true } })
    }
  }

  render() {
    const { companyDetails, locale } = this.props
    const { catalogSelected, showMore } = this.state
    const catalog = this.getCatalog()
    return (
      <BasicLayout selectedKeys={['/company']} menu1Name={'Publishers'}>
        <div className="pageContainer">
          <div className="company">
            <div className="top">
              <div className="logo_name">
                <div className="logo">
                  {companyDetails&&companyDetails.link ? <img alt={'logo'} src={companyDetails.link} style={{width: '100%', height: '100%', objectFit: 'contain'}}/> : null}
                </div>
                <div className="name">{companyDetails&&companyDetails.operator}</div>
              </div>
            </div>
            {/*<div className="describe">*/}
            {/*  {companyDetails&&companyDetails.desc}*/}
            {/*</div>*/}
          </div>
          <div className="table_content">
            <div className="top_search">
              <Row>
                {catalog.map((vo, index)=>{
                  return (
                    <Col key={index} span={24}>
                      <div className="item_line">
                        <div className="title">{locale==='EN' ? vo.nameEN : vo.nameCN}</div>
                        <div className="button_content">
                          {vo.list.map((item, key)=>{
                            // 控制显示数量
                            if (!showMore && key >= 7) {
                              return null
                            }
                            return (
                              <div key={key}
                                   className={`button ${index===0 || index===4 || index===catalogSelected.length-1 ? (catalogSelected[index].value===item.value ? 'button_activity' : null) : (catalogSelected[index].value.indexOf(item.value)>=0||(!catalogSelected[index].value[0] && !item.value) ? 'button_activity' : null) }`}
                                   onClick={()=>{this.handleSelectCatalog(item.value, index)}}
                              >{locale==='EN' ? item.nameEN : (item.nameCN ? item.nameCN : item.nameEN)}</div>
                            )
                          })}
                          {vo.list.length > 7 ? <div className={'button more'}>
                            <span onClick={()=>{this.setState({ showMore: !this.state.showMore })}}>
                              {!showMore ? (locale==='EN' ? 'Expand' : '展开') : (locale==='EN' ? 'Collapse' : '收起')}
                            </span>
                          </div> : null}
                          {
                            index===catalog.length-1&&catalogSelected[index].value==='3'
                              ?
<RangePicker
                              placeholder={['Start Date', 'End Date']}
                              disabledDate={disabledDate}
                              onChange={this.handleChangeDate}
                              style={{padding: '2px 14px 2px', margin: '0 13px 13px 0'}}
                            />
                              :
                              null
                          }
                        </div>
                      </div>
                    </Col>
                  )
                })}
              </Row>
            </div>
            <div className="export_line">
              <div className="export_button" onClick={()=>{this.handleExport()}}><ExportOutlined className="icon"/>{locale==='EN' ? 'Export Data' : '导出'}</div>
            </div>
            {this.renderTable()}
          </div>
        </div>
      </BasicLayout>
    )
  }

}
export default connect(({ company, gameList, user })=>({
  companyGame: company.companyGame,
  page: company.page,
  perPage: company.perPage,
  companyDetails: company.companyDetails,
  segmentList: gameList.segmentList,
  genreList: gameList.genreList,
  userInfo: user.userInfo,
  locale: user.locale
}))(CompanyDetails)